import { Alert } from '@@/Alert';

import { GitReferenceErrorKind } from './useGitCheckStatus';

export function GitReferenceErrorAlert({
  errorKind,
  url,
  reference,
  configFilePath,
  infoMessage,
}: {
  errorKind: GitReferenceErrorKind;
  url?: string | null;
  reference?: string | null;
  configFilePath?: string | null;
  infoMessage?: string;
}) {
  return (
    <>
      <Alert color="error" className="mb-5">
        {errorKind === 'config' && (
          <div>Unable to load the Git configuration for this workflow.</div>
        )}
        {errorKind === 'repo' && (
          <div>
            The git repository <span>{url || ''}</span> could not be reached.
          </div>
        )}
        {errorKind === 'ref' && (
          <div>
            The git reference <span>{reference || ''}</span> could not be found
            on the remote repository.
          </div>
        )}
        {errorKind === 'file' && (
          <div>
            The referenced file{' '}
            <span className="muted">{configFilePath || ''}</span> could not be
            found on the remote repository.
          </div>
        )}
      </Alert>
      {!!infoMessage && (
        <Alert color="info" className="mb-5">
          {infoMessage}
        </Alert>
      )}
    </>
  );
}
